import { IModelPortfolioSubscription } from './../../../models/plannedPortfolios';
import * as ModelPortfoliosActions from './../../model-portfolios/actions/model-portfolios.actions';
import * as PlannedPortfoliosActions from './../actions/planned-portfolios.actions';
import { IPlannedPortfoliosState, initialPlannedPortfoliosState } from './../../state/planned-portfolios.state';
import { plannedPortfolioAdapter } from '../selectors/planned-portfolios.selectors';
export function PlannedPortfoliosReducer(state = initialPlannedPortfoliosState, action: PlannedPortfoliosActions.PlannedPortfoliosActions | ModelPortfoliosActions.ModelPortfoliosActions): IPlannedPortfoliosState {
    switch (action.type) {
        case PlannedPortfoliosActions.PlannedPortfoliosActionTypes.SELECT_PLANNED_PORTFOLIO:
            return {
                ...state,
                loading: true,
                selectedSubscriptionId: action.payload.subscriptionId
            };
        case PlannedPortfoliosActions.PlannedPortfoliosActionTypes.SET_SELECTED_SUBSCRIPTION_ID:
            return {
                ...state,
                selectedSubscriptionId: action.payload
            };
        case ModelPortfoliosActions.ModelPortfoliosActionTypes.DELETE_MODEL_PORTFOLIO_SUBSCRIPTION:
            return {
                ...state,
                selectedSubscriptionId: null
            };
        case PlannedPortfoliosActions.PlannedPortfoliosActionTypes.SELECT_EXISTING_PLANNED_PORTFOLIO_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case PlannedPortfoliosActions.PlannedPortfoliosActionTypes.SELECT_PLANNED_PORTFOLIO_SUCCESS:
        case PlannedPortfoliosActions.PlannedPortfoliosActionTypes.SELECT_PLANNED_PORTFOLIO_FAIL:
            const newState = {
                ...state,
                loading: false
            };
            return plannedPortfolioAdapter.upsertOne(action.payload.selectedTempPlannedPortfolio, newState);
        case PlannedPortfoliosActions.PlannedPortfoliosActionTypes.SUBMIT_PLANNED_PORTFOLIO:
            return {
                ...state,
                loading: true,
                plannedModelPortfolioSubmittedSuccess: false
            };
        case PlannedPortfoliosActions.PlannedPortfoliosActionTypes.SUBMIT_PLANNED_PORTFOLIO_SUCCESS:
            const submitPlannedPortfolioSuccessState = {
                ...state,
                loading: false,
                plannedModelPortfolioSubmittedSuccess: true
            };
            return plannedPortfolioAdapter.upsertOne(action.payload, submitPlannedPortfolioSuccessState);
        case PlannedPortfoliosActions.PlannedPortfoliosActionTypes.PLANNED_PORTFOLIOS_DATA_ERROR:
            return {
                ...state,
                loading: false,
                plannedPortfolioDataError: {
                    failText: action.payload
                }
            };
        case PlannedPortfoliosActions.PlannedPortfoliosActionTypes.CANCEL_TEMPORARY_PLANNED_PORTFOLIO:
            return plannedPortfolioAdapter.removeOne(action.payload, state);
        case PlannedPortfoliosActions.PlannedPortfoliosActionTypes.RESET_PLANNED_PORTFOLIO:
            return {
                ...state,
                loading: false,
                plannedPortfolioDataError: null
            };
        case ModelPortfoliosActions.ModelPortfoliosActionTypes.SUBMIT_MODEL_PORTFOLIO_SUCCESS:
            const toBeRemovedSubscriptionIds = action.payload.subscriptions.map((s: IModelPortfolioSubscription) => s.id);
            return plannedPortfolioAdapter.removeMany(toBeRemovedSubscriptionIds, state);
        default:
            return state;
    }
}
